import react, {useEffect,useState} from 'react';
import { Image as AntdImage, Spin, Tooltip } from 'antd';
import { MenuFoldOutlined } from '@ant-design/icons';
import { useSelector } from "react-redux";

import Api from "../../api";
import singleLogo from "../../assets/img/V7/singleLogo.svg";
import Iconfont from "../../components/Iconfont/Iconfont";
import leftSolid from "../../assets/img/V7/leftSolid.svg";
import DepartmentTree from "./components/departmentTree/index"
import PolicyTree from "./components/policyTree/index"
import ResearchReportTree from "./components/researchReportTree/index"
import OverseasCasesTree from "./components/overseasCasesTree/index"
import KnowledgeList from "./components/knowledgeList/index"
import PolicyList from "./components/policyList/index"
import AIQAPage from "../../components/AIQAPage/index"
import PersonalTree from "./components/personalTree/index"
import KnowledgeTypeList from "./components/knowledgeTypeList/index"
import NoteTypeList from "./components/noteTypeList/index"

import KnowledgeSystemManage from "../personalCenter/myNote/noteManage/knowledgeSystemManage";
import NoteOriginal from "../personalCenter/myNote/noteManage/noteOriginal";
import ExcerptList from "../personalCenter/myNote/noteManage/ExcerptList";


import { getSearchParams } from '../../utils/tool'
import './index.scss';


const KnowledgeCentre = ({history}) => {

    const [knowledgeType, setKnowledgeType] = useState([]);
    const [personalKnowledgeType, setPersonalKnowledgeType] = useState([
        {knowledgeTypeName:"个人资料" , id: "personalData", icon: "icon-fangzi"},
        {knowledgeTypeName:"专题收藏" , id: "collection", icon: "icon-shoucang2"},
        {knowledgeTypeName:"阅读笔记" , id: "leadingNote", icon: "icon-shu1"}
    ]);
    const [knowledgeTypeItem, setKnowledgeTypeItem] = useState({});
    

    // 列表数据
    const [loadingType, setLoadingType] = useState(false);
    const [listDate, setListDate] = useState([]);
    // 查询数据
    const [searchData, setSearchData] = useState({
        "pageIndex":1,
        "pageSize":10,
    });
    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });

    const [openStatus, setOpenStatus] = useState(true);

    const [noteTypeId, setNoteTypeId] = useState(null);

    const refreshSpaceList = useSelector(state => state.AIReducerV7.refreshSpaceList);
    
    useEffect(()=>{ 
        if(refreshSpaceList){
            if(searchData.knowledgeTypeId === 'personalData'){
                getSpaceList();
            }else if(searchData.knowledgeTypeId === 'collection'){
                getCollectionList();
            }else if(searchData.knowledgeTypeId == '4'){
                getPolicyList();
            }else if(searchData.knowledgeTypeId != 'leadingNote'){
                getKnowledgeList();
            }
        }
    },[refreshSpaceList])

    useEffect(()=>{
        getInitDate();
    },[])

    useEffect(()=>{
        if(searchData.knowledgeTypeId){
            setListDate([]);
            setPagination({
                "pageIndex": 0,
                "pageSize": 0,
                "total":0
            });
            
            if(searchData.knowledgeTypeId === 'personalData'){
                getSpaceList();
            }else if(searchData.knowledgeTypeId === 'collection'){
                getCollectionList();
            }else if(searchData.knowledgeTypeId == '4'){
                getPolicyList();
            }else if(searchData.knowledgeTypeId != 'leadingNote'){
                getKnowledgeList();
            }
        }
    },[JSON.stringify(searchData)])
    

     const getInitDate = async() => {
        const res = await Api.Knowledge.getAllKnowledger({});
        if(res && res.code === 0){
            if(getSearchParams().knowledgeTypeId === "leadingNote"){
                changeKnoeledgeType({knowledgeTypeName:"阅读笔记" , id: "leadingNote", icon: "icon-shu1"});
            }else if(getSearchParams().knowledgeTypeId){
                res.data.map(item => {
                    if(item.id == getSearchParams().knowledgeTypeId){
                        changeKnoeledgeType(item);
                    }
                })
            }else{
                changeKnoeledgeType(res.data[0]);
            }
            // changeKnoeledgeType({
            //     id:"personalData",
            //     knowledgeTypeName:"个人资料"
            // });
            setKnowledgeType([
                ...res.data
            ]);
        }
    }

    const changeKnoeledgeType = (item) =>{
        if(item.knowledgeTypeId != 'leadingNote'){
            setNoteTypeId(null);
        }
        setKnowledgeTypeItem(item);
        let _searchData = {
            "pageIndex":1,
            "pageSize":10,
            "knowledgeTypeId": item.id
        };
        setSearchData(_searchData);
    }

    const changePersonalKnoeledgeType = (item) =>{
        setKnowledgeTypeItem(item);
    }

    // 知识中心获取知识列表
    const getKnowledgeList = async() => {
        setLoadingType(true);

        let _searchData = {...searchData};

        let res = "";
        
        if((_searchData.knowledgeName || _searchData.startTime) && _searchData.knowledgeTypeId != '7'){
            // 其他基础知识类型搜索标题的时候走ES的接口
            _searchData.knowledgeTypeIds = [_searchData.knowledgeTypeId]
            _searchData.text = _searchData.knowledgeName;
            _searchData.searchResearchReport = false;
            _searchData.searchType = "1";
            delete _searchData.knowledgeName;
            delete _searchData.knowledgeTypeId;
            res = await Api.Knowledge.getESSearch({data:_searchData});
        }else if((_searchData.knowledgeName || _searchData.startTime) && _searchData.knowledgeTypeId === '7'){
            // 参考研报搜索标题的时候走ES的接口
            // _searchData.knowledgeType = _searchData.knowledgeTypeId
            _searchData.knowledgeTypeIds = [_searchData.knowledgeTypeId];
            _searchData.text = _searchData.knowledgeName;
            _searchData.searchType = "1";
            delete _searchData.knowledgeName;
            delete _searchData.knowledgeTypeId
            res = await Api.Knowledge.getESSearch({data:_searchData});
        }else if(_searchData.knowledgeTypeId === '7'){ 
            res = await Api.Knowledge.getPutKnowledgeList({data:_searchData});
        }else{
            res = await Api.Knowledge.getKnowledgePageListV7({data:_searchData});
        }

        setLoadingType(false);
        if(res && res.code === 0 && res.data && res.data.records && res.data.records.length > 0){
            setListDate(res.data.records);
            setPagination({
                "pageIndex": res.data.current,
                "pageSize": res.data.size,
                "total":res.data.total,
            })
        }else{
            setListDate([]);
        }
    }

    // 获取政策列表
    const getPolicyList = async() => {
        setLoadingType(true);
        let _searchData = {...searchData};
        if(_searchData.regionId === 999){
            delete _searchData.regionId
        }

        _searchData.search = _searchData.knowledgeName;
        _searchData.searchType = 1;
        delete _searchData.knowledgeName;

        if(_searchData.codes && _searchData.codes.length > 0){
            _searchData.countryDeptIds = [..._searchData.countryDeptIds, ..._searchData.codes];
            _searchData.codes = [];
        }

        try {
            let res = await Api.Knowledge.getPolicyPageList({data:{
                ..._searchData,
            }});
            setLoadingType(false);
            if(res && res.code === 0 && res.data.records){
                setListDate(res.data.records);
                setPagination({
                    "pageIndex": res.data.current,
                    "pageSize": res.data.size,
                    "total":res.data.total,
                })
            }else{setListDate([]);}
        } catch (errInfo) {
            setListDate([]);
            setLoadingType(false);
            console.log('验证失败:', errInfo);
        }
    }

    // 个人资料
    const getSpaceList = async () => {
        let _searchData = {...searchData};

        if (_searchData.knowledgeName) {
            _searchData.name = _searchData.knowledgeName;
            delete _searchData.knowledgeName;
        }

        delete _searchData.knowledgeTypeId;

        setLoadingType(true);
        try {
             const res = await Api.PersonalCenter.getSpaceLKist({
                data: _searchData,
            });
            setLoadingType(false);
            if (res && res.code == 0) {
                setListDate(res.data.records);
                setPagination({
                    "pageIndex": res.data.current,
                    "pageSize": res.data.size,
                    "total":res.data.total,
                })
            }
        }catch (errInfo) { 
            setListDate([]);
            setLoadingType(false);
        }
       
    }

    const getCollectionList = async() => {
        
        let _searchData = {...searchData};
        _searchData.knowledgeTypeId = _searchData.collectKnowledgeTypeId

        setLoadingType(true);
        try {
             const res = await Api.PersonalCenter.getKnowledgeCollection({
                data: _searchData,
            });
            setLoadingType(false);
            if (res && res.code == 0) {
                setListDate(res.data.records);
                setPagination({
                    "pageIndex": res.data.current,
                    "pageSize": res.data.size,
                    "total":res.data.total,
                })
            }
        }catch (errInfo) { 
            setListDate([]);
            setLoadingType(false);
        }
    }

    const changeOpenStatus = () =>{
        setOpenStatus(!openStatus)
    }

    const deparmentChange = (deptVos) =>{
        let _searchData = {...searchData};
        _searchData.pageIndex = 1;
        _searchData.deptVos = deptVos;
        _searchData.knowledgeTypeId = knowledgeTypeItem.id;
        setSearchData(_searchData);
    }

    const treeSelectChange = (value) =>{
        let _searchData = {
            "pageIndex":1,
            ...searchData,
            ...value
        };
        setSearchData(_searchData);
    }

    const noteTypeListChange = (value) => {
        setNoteTypeId(value);
    }

    const overseasChange = (value) =>{
        let _searchData = {
            ...searchData,
            ...value
        };
        setSearchData(_searchData);
    }

    const policyTreeChange = (value) => {
        console.log(value,"value")
        let _searchData = {
            ...searchData,
            ...value
        };
        setSearchData(_searchData);
    }

    const searchChange = (param) =>{
        let _searchData = {
            ...searchData,
            ...param
        };
        setSearchData(_searchData);
    }

    const paginationChange = (pageIndex,pageSize) =>{
        let _searchData = {
            ...searchData,
            "pageIndex": pageIndex,
            "pageSize": pageSize,
        };
        setSearchData(_searchData);
    }

    const goBack = () =>{
        history.replace("/page/homePage");
    }

    return(
    <div className="knowledgeCentreFrame">
        <div className="knowledgeClassification">
            <AntdImage
                src={singleLogo}
                preview={false}
                className="singleLogo"
                onClick={()=>{
                    history.push("/page/homePage")
                }}
            />
            <div className="title">公共知识库</div>
            <div className="knowledgeList">
                {knowledgeType.map((item, index) => ( 
                    <div className={`knowledgeListItem ${knowledgeTypeItem.id === item.id ? 'active':''}`} key={item.id} onClick={()=>{changeKnoeledgeType(item)}}>
                        <AntdImage
                            width={16}
                            preview={false}
                            src={item.url}
                            className="knowledgeTypeLogo"
                        />
                        <div className="knowledgeTypeName">{item.knowledgeTypeName}</div>
                    </div>
                ))}
            </div>
            <div className="title">个人知识库</div>
 
            <div className="knowledgeList">
                {personalKnowledgeType.map((item, index) => ( 
                    <div className={`knowledgeListItem ${knowledgeTypeItem.id === item.id ? 'active':''}`} key={item.id} onClick={()=>{changeKnoeledgeType(item)}}>
                        <Iconfont type={item.icon}/>
                        <div className="knowledgeTypeName">{item.knowledgeTypeName}</div>
                    </div>
                ))}
            </div>
            
        </div>
        <div className={`knowledgeClassificationTree ${openStatus ? 'knowledgeClassificationTreeOpen' : 'knowledgeClassificationTreeClose'}`}>
            <div className="topNav">
                <div style={openStatus ? {opacity: 1} :{opacity: 0}}> 
                    <AntdImage
                        preview={false}
                        src={leftSolid}
                        onClick={()=>goBack()}
                    />
                    {knowledgeTypeItem.knowledgeTypeName}
                </div>

                <Tooltip title={openStatus ? "收起" : "展开"}>
                    <MenuFoldOutlined onClick={()=>changeOpenStatus()}/>
                </Tooltip>
            </div>
            
            <div className="treeContentBox">
                {knowledgeTypeItem.id === 'personalData' ? <PersonalTree treeSelectChange={treeSelectChange}/> : 
                knowledgeTypeItem.id === 'collection' ? <KnowledgeTypeList treeSelectChange={treeSelectChange}/> : 
                knowledgeTypeItem.id === 'leadingNote' ? <NoteTypeList noteTypeListChange={noteTypeListChange}/> : 
                knowledgeTypeItem.id === '4' ? <PolicyTree policyTreeChange={policyTreeChange}/> : 
                knowledgeTypeItem.id === '7' ? <ResearchReportTree  researchReportChange={treeSelectChange}/> : 
                knowledgeTypeItem.id === '9' ? <OverseasCasesTree overseasChange={treeSelectChange}/> : 
                <DepartmentTree knowledgeTypeId={knowledgeTypeItem.id} deparmentChange={deparmentChange}/>}
            </div>
            
            
        </div>
        
        <Spin 
            spinning={loadingType} 
            wrapperClassName="knowledgeContentList" 
            style={noteTypeId === '1'?{padding: '0'}:{}}
        >
            {noteTypeId === '1'?<KnowledgeSystemManage pageType="knoewledgeCenter"/>:
            noteTypeId === '2'?<NoteOriginal pageType="knoewledgeCenter"/>:
            noteTypeId === '3'?<ExcerptList pageType="knoewledgeCenter"/>:
            knowledgeTypeItem.id === '4' ? 
                // 政策跟踪
                <PolicyList
                    searchData={searchData}
                    listDate={listDate} 
                    pagination={pagination}
                    knowledgeTypeId={knowledgeTypeItem.id}
                    searchChange={searchChange}
                    paginationChange={paginationChange}
                /> :
            // 基础知识列表
            <KnowledgeList
                searchData={searchData}
                listDate={listDate} 
                pagination={pagination}
                knowledgeTypeId={knowledgeTypeItem.id}
                searchChange={searchChange}
                paginationChange={paginationChange}
            /> }
        </Spin>
        
        {/* AI知识问答 */}
        {knowledgeTypeItem.id && knowledgeTypeItem.id != 'leadingNote'&&<AIQAPage pageType={knowledgeTypeItem.id}/>}
        
    </div>
    )
}

export default KnowledgeCentre;